module.exports = __webpack_public_path__ + "img/45.b0ba44a9.jpg";